// ===== Shared Type Definitions =====
// Used by both frontend and backend to ensure API contract consistency.
export const COLOR_SLOTS = ['A', 'B', 'C', 'D', 'E', 'F'];
// ----- Color Slot Helpers -----
export const EMPTY_SLOT = Symbol('empty');
/**
 * Build A-F slot grid from color records.
 * Returns all 6 slots, filling empty ones with null.
 */
export function buildSlotGrid(colors) {
    const map = new Map();
    for (const c of colors) {
        map.set(c.code, c);
    }
    return COLOR_SLOTS.map((code) => ({
        code,
        color: map.get(code) ?? null,
    }));
}
/**
 * Find the next available slot for auto-assignment.
 * Priority: empty slot > pending > none (returns null if full).
 */
export function findNextSlot(colors) {
    const occupied = new Set(colors.map((c) => c.code));
    // 1. Find first empty slot
    for (const slot of COLOR_SLOTS) {
        if (!occupied.has(slot))
            return slot;
    }
    // 2. Find first pending slot
    const pending = colors
        .filter((c) => c.status === 'pending')
        .sort((a, b) => a.code.localeCompare(b.code));
    if (pending.length > 0)
        return pending[0].code;
    // 3. Full
    return null;
}
/**
 * Check if all 6 slots are full (no empty, no pending).
 */
export function isSlotsFull(colors) {
    return findNextSlot(colors) === null;
}
